var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scope-arrangement-setting"
  }, [_c('div', {
    staticClass: "box-shadow-small border-radius"
  }, [_c('div', {}, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mb-15"
  }, [_c('thumbnail', {
    attrs: {
      "text": _vm.baseInfo.name,
      "gender": _vm.baseInfo.gender === 1 ? 'man' : 'woman',
      "font-size": 16,
      "width": 110
    }
  }), _vm._v(" "), _c('el-row', {
    staticClass: "mt-10 text-center",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("应聘职位：" + _vm._s(_vm.baseInfo.positionName))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("应聘部门：" + _vm._s(_vm.baseInfo.deptNames))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("手机号：" + _vm._s(_vm.baseInfo.mobilePhone))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mt-20"
  }, [_c('el-row', {
    staticClass: "arrangement-list"
  }, [_c('arrangement-item', {
    ref: "arrangement",
    attrs: {
      "init": _vm.baseData
    },
    on: {
      "sendEmail": _vm.sendEmail
    }
  })], 1)], 1)]), _vm._v(" "), _c('email-sender', {
    ref: "sendEmail"
  })], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "clearfix mt-15 ml-20"
  }, [_c('strong', [_vm._v("面试安排")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a00768f"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/arrangement/arrangement.vue
// module id = null
// module chunks = 